import * as Sentry from '@sentry/react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, FormControl, InputLabel,  MenuItem, Select, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Acent from 'components/Acent';
import Loading from 'components/Loading';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { default as COLOR, default as color } from 'utils/constants/color';
import { disableBodyScroll } from 'utils/methods/math';
import { get, has } from "lodash";
import { handleAssignGraphicOrgToEbook, handleUpdateGraphicOrgToEbook } from 'store/activities/thunks';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------



//  -- Constants ----------------------








//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const LABEL = ['a', 'b', 'c', 'd', 'e']

// const ASSIGNMENT_BG = ['#cfd5d045', '#dbe4f0', '#58aedb4f', '#dda4e74d', '#3fdd6645', '#e9bf864d']



const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 25px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;



const Wrapper = styled.div`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px;
`;



const Image = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
    height:100%;
    margin-right: 16px;
    padding-right: 10px;
`;




const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    },
    checkroot: {
        display: 'flex',
        flexDirection: 'column'
    },
    checkformControl: {
        minWidth: 300,
    },
    checksectionTitle: {
    },
    formGroup: {
        flexDirection: 'row', // Arrange checkboxes in a row
        gap: 12
    },
    checkbox: {
        '&.Mui-checked': {
            color: color.green100, // Custom checked color (green)
        },
    },
}));


const GraphicAssignmentForm = ({
    pageSrc,
    data,
    bookId,
    pageId,
    assignment,
    onClose = () => { }
}) => {
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const classes = useStyles();
    const [displayName, setdisplayName] = useState('')
    const [colorCode, setcolorCode] = useState('')
    const [loading, setLoading] = useState(false)
    const [errors, setError] = useState([])
    const dispatch = useDispatch()
    const isEditing = has(data, "id")
    const dispNameRef = useRef();

    useEffect(() => {
        if(assignment){
            setdisplayName(assignment.displayName)
            setcolorCode('');
        }
    }, [assignment]);
    const onSubmit = async (e) => {
        try {
            const error = []

            setLoading(true)

            if (!displayName) {
                error.push({ type: 'display_name', message: 'Displayname required' })
            }
            if(isEditing){
                const created_assignment = await dispatch(handleUpdateGraphicOrgToEbook( assignment.id, displayName, colorCode))
                if (created_assignment && created_assignment.success) {
                    onClose()
                }
            }else{
                const created_assignment = await dispatch(handleAssignGraphicOrgToEbook(pageId, bookId, assignment.id, 'admin', displayName, colorCode))
                if (created_assignment && created_assignment.success) {
                    onClose()
                }
            }
           
            setError(error)
        } catch (error) {
            Sentry.captureException(`317 Error in GraphicAssignmentForm: ${error}`);
            console.log(error);
        } finally {
            setLoading(false);
        }

    };


    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        // document.body.style.overflow = "hidden";
        disableBodyScroll("Form")

        return () => {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <>
            <Wrapper>

                <Row className="editQuizUpr">
                    <Col xs={24} sm={12} md={12} style={{ padding: "16px 10px" }}>
                        <ImageContiner>
                            <Image src={pageSrc} alt='' />
                        </ImageContiner>
                    </Col>
                    <Col xs={24} sm={12} md={12} style={{ padding: "16px 16px" }}>
                        <Header>{isEditing ? `Edit Activity` : `Create Activity`}</Header>
                        <Row justify="start" style={{ marginBottom: 10, alignItems: "flex-end" }} gutter={[15, 15]}>
                            <Col span={16}>
                                <Acent inputRef={dispNameRef} setValue={setdisplayName} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                <TextField
                                    id="displayName"
                                    name="displayName"
                                    label="Display Name"
                                    InputLabelProps={{ shrink: true, required: true }}
                                    type="text"
                                    required
                                    inputRef={dispNameRef}
                                    variant="outlined"
                                    onChange={e => {
                                        setdisplayName(e.target.value)
                                    }}
                                    value={displayName}
                                />
                            </Col>
                        </Row>
                        {/* <Row justify="start" style={{ marginBottom: 20, marginTop: 20 }}>
                            <Col span={12} className='floatingLabelBG newfloatingLabelBG'>
                                <FormControl variant="outlined" className={classes.formControl} style={{ backgroundColor: colorCode || '#fff' }}>
                                    <InputLabel id="type">Background color</InputLabel>
                                    <Select
                                        labelId="colorCode"
                                        id="colorCode"
                                        required={false}
                                        value={colorCode || '#fff'}
                                        onChange={(v) => {
                                            setcolorCode(v.target.value)
                                        }}
                                        label="Color"
                                    >
                                        {ASSIGNMENT_BG.map(clr => <MenuItem key={clr} style={{ backgroundColor: clr }} value={clr}>{clr}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Col>

                        </Row> */}
                        {errors.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                            {errors.map(v => (<Typography variant="subtitle2" key={v.type} style={{ whiteSpace: "pre-wrap" }} color="error">
                                * {get(v, "message")}
                            </Typography>))}
                        </Row> : null}
                        <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                            <Button fullWidth
                                onClick={onSubmit}
                                disabled={(!displayName || displayName.length == 0) || loading || buttonDisabled}
                                variant="contained"
                                color="primary">
                                {loading ? <Loading white size={15} /> : null} {isEditing ? "Update" : "Create"}
                            </Button>
                        </Row>
                    </Col>
                </Row>
            </Wrapper>
        </>

    );
};




export default GraphicAssignmentForm;